import axios, { AxiosResponse } from "axios";
import { getAccessToken, handleUnauthorized } from "../auth";
import { getUserFacingError } from "./userFacingError";

async function getApi(url: string, payload?: any): Promise<any> {
  try {
    const response: AxiosResponse = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': `Bearer ${getAccessToken()}`
      }
    });
    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      if (status === 401 || status === 403) {
        handleUnauthorized();
      }
    }
    return {
      message: getUserFacingError(error),
      status_code: axios.isAxiosError(error) ? error.response?.status || 0 : 0,
      __userFacingError: true,
    };
  }
}

export default getApi;
